export const SEARCH_PATH = '/api/search_categories';
